import { useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '@/services/api/axios.ts';

export const useDeleteNotificationQuery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ notificationId }: { notificationId: string | undefined }) => {
      if (!notificationId) return;
      const { data } = await client.delete(`/notifications/${notificationId}`);
      return data;
    },
    /**
     * Known issue: If we delete a notification that DynamoDB is using as next cursor
     * for loading the next page, then loading more notifications will break because
     * that next cursor no longer exists.
     *
     *
     * TODO: Handle the case where the "next cursor" is deleted
     */
    // onMutate: async (notification) => {
    //   await queryClient.cancelQueries({ queryKey: ['notifications'] });
    //   const previousNotifications: InfiniteData<GetNotificationsQueryResponse> | undefined =
    //     queryClient.getQueryData(['notifications']);
    //
    //   queryClient.setQueryData<InfiniteData<GetNotificationsQueryResponse | undefined>>(
    //     ['notifications'],
    //     (previousInfiniteQueryData: any) => {
    //       return {
    //         ...previousInfiniteQueryData,
    //         pages: previousNotifications?.pages?.map((page) => {
    //           const newBody = page.body.filter((post) => {
    //             return post.notificationId !== notification.notificationId;
    //           });
    //
    //           return {
    //             ...page,
    //             body: newBody,
    //             length: newBody.length,
    //           };
    //         }),
    //       };
    //     }
    //   );
    //
    //   return { previousNotifications };
    // },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
    // onError: (_1, _2, context) => {
    //   queryClient.setQueryData(['notifications'], context?.previousNotifications);
    // },
  });
};
